import { apiGet, apiPut, API_URI, CRM_API_URI } from './index';

const products = {
    getAll: async (projectId: number) => {
        const data = await apiGet(`${CRM_API_URI}/api/project/${projectId}/products`);
        return data;
    },
    addToAgreement: async (clientId: number, projectId: number) => {
        
    }
}

export default products;